<template>
  <div class="txn-wrap">
    <div id="queryRequest" class="line-chart"></div>
  </div>
</template>

<script>
let echarts = require('echarts')
export default {
  name: 'QueryRequest',
  data() {
    return {
      chart: null,
      intervalId: null,
      option: {
        grid: {
          left: '1%',
          right: '8%',
          bottom: '8%',
          top: '5%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          // data: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
          axisLine: {
            // 调整轴线颜色
            lineStyle: {
              color: '#306269'
            }
          },
          axisTick: {
            // 去掉刻度
            show: false
          },
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            textStyle: {
              color: '#fff'
              // fontWeight: 'bold'
            }
          },
          inverse: false,
          splitLine: {
            axisLabel: {
              textStyle: {
                color: 'green' // 设置为绿色
              }
            },
            lineStyle: {
              color: '#306269',
              width: 0.5
            }
          }
        },
        series: [
          {
            type: 'line',
            smooth: 'none',
            symbol: 'none',
            label: {
              show: true
            }
            // lineStyle: {
            //     color: '#FFCC00',
            //     width: 1,
            //     type: 'solid'
            // }
          }
        ]
      }
    }
  },
  watch: {
    '$store.state.home.chainCid'(newValue) {
      if (newValue) this.getData()
    }
  },

  mounted() {
    this.initChart()
    this.getData()
    this.intervalId = setInterval(() => {
      this.getData()
    }, 10000)
    window.addEventListener('resize', this.resize, false)
  },
  destroyed() {
    // 清除定时器和图表实例
    clearInterval(this.intervalId)
    this.chart.dispose()
  },
  methods: {
    initChart() {
      let container = document.getElementById('queryRequest')
      let chart = echarts.init(container)
      chart.setOption(this.option)
      this.chart = chart
    },
    resize() {
      this.chart.resize()
    },

    getData() {
      let cid = this.$store.state.home.chainCid

      let params = {
        chain_id: cid,
        data_type: 1,
        query_range: 0,
        query_step: '',
        query_time: Math.floor(Date.now() / 1000)
      }
      this.$apis.home.getMultiple(params).then(res => {
        if (res.data) {
          const yTimeArray = res.data.time_axis.map((item, index) => {
            return this.timestampToTime(item)
          })

          var seriesArray = []

          res.data.multiple_data.map((item, index) => {
            var obj = {}
            obj.data = item.nums
            obj.name = item.instance
            obj.symbol = 'none'
            obj.type = 'line'
            obj.smooth = true
            if (index == 0) {
              obj.areaStyle = {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#00CBFF' },
                  { offset: 1, color: 'rgba(0,0,0,0)' }
                ])
              }
              obj.itemStyle = {
                emphasis: {
                  opacity: 0
                },
                color: '#00CBFF',
                borderWidth: 1,
                borderColor: '#00CBFF'
              }
            } else if (index == 1) {
              obj.areaStyle = {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#FFCC00' },
                  { offset: 1, color: 'rgba(0,0,0,0)' }
                ])
              }
              obj.itemStyle = {
                emphasis: {
                  opacity: 0
                },
                color: '#FFCC00',
                borderWidth: 1,
                borderColor: '#FFCC00'
              }
            } else if (index == 2) {
              obj.areaStyle = {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#e6762c' },
                  { offset: 1, color: 'rgba(0,0,0,0)' }
                ])
              }
              obj.itemStyle = {
                emphasis: {
                  opacity: 0
                },
                color: '#e6762c',
                borderWidth: 1,
                borderColor: '#e6762c'
              }
            } else if (index == 3) {
              obj.areaStyle = {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#27dfed' },
                  { offset: 1, color: 'rgba(0,0,0,0)' }
                ])
              }
              obj.itemStyle = {
                emphasis: {
                  opacity: 0
                },
                color: '#27dfed',
                borderWidth: 1,
                borderColor: '#27dfed'
              }
            } else if (index == 4) {
              obj.areaStyle = {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#fd3838' },
                  { offset: 1, color: 'rgba(0,0,0,0)' }
                ])
              }

              obj.itemStyle = {
                emphasis: {
                  opacity: 0
                },
                color: '#fd3838',
                borderWidth: 1,
                borderColor: '#fd3838'
              }
            }
            seriesArray.push(obj)
          })

          this.chart.setOption({
            xAxis: {
              data: yTimeArray
            },
            series: seriesArray
          })
        }
      })
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp * 1000) // Fri Aug 26 2022 01:09:43 GMT+0800 (中国标准时间)
      let Y = date.getFullYear() + '-'
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return h + m + s
    },
    handleLine(data) {
      let hour = []
      let num = []
      data.map(ele => {
        let time = this.format(ele.Hourtime)
        hour.push(time)
        num.push(ele.Num)
      })
      return [hour, num]
    },
    add0(m) {
      return m < 10 ? '0' + m : m
    },
    format(timeStamp) {
      let time = new Date(timeStamp * 1000)
      let m = time.getMonth() + 1
      let d = time.getDate()
      let h = time.getHours()
      let mm = time.getMinutes()
      let s = time.getSeconds()
      return this.add0(m) + '-' + this.add0(d) + ' ' + this.add0(h) + ':' + this.add0(mm)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/compatible/index.scss';

.real-wrap,
.line-chart {
  @include px2vw(width, 400);
  @include px2vw(height, 240);
}
</style>
